module.exports = __webpack_public_path__ + "img/pe.ef9dac1d.svg";